import api from '../services/api';

// Sin URL sandbox: el backend debe devolver el permalink productivo configurado.
const FALLBACK = [
  { id: 'pago_sede', label: 'Pago en sede', url: null },
];

export async function fetchPaymentMethods(moduleCode = 'd28d', opts = {}) {
  try {
    const q = new URLSearchParams({ module: String(moduleCode) });
    const programId = opts.programId ?? opts.program_id;
    if (programId) q.set('program_id', String(programId));
    const r = await api.get(`/payment-links/public?${q.toString()}`, {
      skipShellAuth: true,
    });
    const methods = r.data?.data?.methods;
    if (Array.isArray(methods) && methods.length) return methods;
  } catch { /* fallback */ }
  return FALLBACK;
}

/**
 * Abre Wompi. Preferir `openWompiCheckoutPlaceholder` + `navigateWompiCheckout`
 * cuando el click dispara un await (evita bloqueo de popup).
 */
export function openWompiCheckout(url) {
  if (!url) return false;
  const win = window.open(url, '_blank', 'noopener,noreferrer');
  if (win && !win.closed) return true;
  // Popup bloqueado: misma pestaña para no perder el pago.
  window.location.assign(url);
  return true;
}

/**
 * Web Checkout Wompi con monto fijo (amount-in-cents).
 * Preferible al enlace /l/ abierto, que ignora el precio y muestra $0.
 */
export function openWompiWebCheckout(checkout) {
  if (!checkout?.action || !checkout?.fields) return false;
  try {
    const form = document.createElement('form');
    form.method = String(checkout.method || 'GET').toUpperCase() === 'POST' ? 'POST' : 'GET';
    form.action = checkout.action;
    form.target = '_blank';
    form.rel = 'noopener noreferrer';
    form.style.display = 'none';
    Object.entries(checkout.fields).forEach(([name, value]) => {
      if (value == null) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = String(value);
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    setTimeout(() => {
      try { form.remove(); } catch { /* noop */ }
    }, 1000);
    return true;
  } catch {
    return false;
  }
}

/** Abrir en el gesto del usuario (antes del await). */
export function openWompiCheckoutPlaceholder() {
  try {
    return window.open('about:blank', '_blank');
  } catch {
    return null;
  }
}

export function navigateWompiCheckout(placeholderWin, url) {
  if (!url) {
    try { placeholderWin?.close?.(); } catch { /* noop */ }
    return false;
  }
  if (placeholderWin && !placeholderWin.closed) {
    try {
      placeholderWin.location.href = url;
      return true;
    } catch {
      try { placeholderWin.close(); } catch { /* noop */ }
    }
  }
  return openWompiCheckout(url);
}

export function navigateWompiWebCheckout(placeholderWin, checkout) {
  if (!checkout?.action || !checkout?.fields) {
    try { placeholderWin?.close?.(); } catch { /* noop */ }
    return false;
  }
  if (placeholderWin && !placeholderWin.closed) {
    try {
      const params = new URLSearchParams();
      Object.entries(checkout.fields).forEach(([k, v]) => {
        if (v != null) params.set(k, String(v));
      });
      placeholderWin.location.href = `${checkout.action}?${params.toString()}`;
      return true;
    } catch {
      try { placeholderWin.close(); } catch { /* noop */ }
    }
  }
  return openWompiWebCheckout(checkout);
}
